import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import ShippingDetailsTab from './Freight/ShippingDetailsTab';
import RoutingTab from './Freight/RoutingTab';
import { useDispatch, useSelector } from 'react-redux';
import {
    getJobOrderAirlineList,
    getJobOrderAirportList,
    getJobOrderCurrencyList,
    getJobOrderCustomerList,
    getJobOrderFreightDetails,
    getJobOrderIncotermList,
    getJobOrderPortList,
    getJobOrderSeaportList,
    getJobOrderShiplineList,
    getJobOrderEntityDetails,
} from '../../../../../Redux/action/Joborder/JoborderAction';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import InputTextJSX from './InputTextJSX';
import { customStyles } from '../../../../../HelperFunctions';
import {
    applyNoOfCopiesValidation,
    handleNoOfCopiesInputChange,
    handleTypeOfBlSelectChange,
} from '../../Forwarding/Dynamic/Sea/Export/ffBlCopiesFieldUtils';
import {
    getFFAirExpConsigneeBranch,
    getFFAirExpConsigneeBranchBank,
    getFFAirExpOrganisation,
    getFFAirExpShipperBranch,
    getFFAirExpShipperBranchBank,
} from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';

const FreightSeaTab = ({ token, user_id, b64id, transmode, iataAgentOptions }) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(true);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const hasFetchedJobOrder = useRef(false);   // ✅ prevent multiple direct axios calls

    // ✅ Direct Axios call for Job Order Details (to get pol & pod)
    useEffect(() => {
        if (hasFetchedJobOrder.current) return;
        if (!token || !user_id || !b64id) return;

        const id = atob(b64id);
        if (!id) return;

        const apiUrl = `${adminMainUrl}/api/jobOrder/view`;
        const config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const body = { id };

        axios.post(apiUrl, body, config)
            .then(response => {
                if (response.data?.data) {
                    const jobOrderData = response.data.data;

                    console.log(jobOrderData, 'this is jobOrdrData there have been issue ')

                    if (jobOrderData.pol && (!formik.values.port_of_loading || formik.values.port_of_loading === 0)) {
                        formik.setFieldValue('port_of_loading', jobOrderData.pol);
                    }
                    if (jobOrderData.pod && (!formik.values.port_of_discharge || formik.values.port_of_discharge === 0)) {
                        formik.setFieldValue('port_of_discharge', jobOrderData.pod);
                    }

                    if (jobOrderData.consignee_id && (!formik.values.consignee_id || formik.values.consignee_id === 0)) {
                        formik.setFieldValue('consignee_id', jobOrderData.consignee_id);
                        if (token && user_id) {
                            dispatch(getFFAirExpConsigneeBranch(token, user_id, jobOrderData.consignee_id));
                        }
                    }
                }
            })
            .catch(error => {
                console.log("ERROR in direct JobOrderDetails fetch:", error);
            });

        hasFetchedJobOrder.current = true;
    }, [token, user_id, b64id]);

    // ---------- Redux thunks for other data ----------
    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderShiplineList());
            dispatch(getJobOrderSeaportList());
            dispatch(getJobOrderAirportList());
            dispatch(getJobOrderPortList());
            dispatch(getJobOrderAirlineList());
            dispatch(getJobOrderCustomerList(token, user_id));
            dispatch(getJobOrderIncotermList());
            dispatch(getJobOrderCurrencyList());
            dispatch(getFFAirExpOrganisation(token, user_id));

            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderFreightDetails(token, user_id, id));
                    dispatch(getJobOrderEntityDetails(token, user_id, id));
                }
            }
        }
    }, [token, user_id, b64id]);

    const refreshFreightData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderFreightDetails(token, user_id, id));
            }
        }
    };

    let {
        loadingJobOrderFreightDetail,
        JobOrderFreightDetailError,
        JobOrderFreightDetail,

        loadingJobOrderAirlineList,
        JobOrderAirlineList,
        JobOrderAirlineListError,

        loadingJobOrderShiplineList,
        JobOrderShiplineList,
        JobOrderShiplineListError,

        loadingJobOrderPortList,
        JobOrderPortList,
        JobOrderPortListError,

        loadingJobOrderAirportList,
        JobOrderAirportList,
        JobOrderAirportListError,

        loadingJobOrderSeaportList,
        JobOrderSeaportList,
        JobOrderSeaportListError,

        loadingJobOrderCustomerList,
        JobOrderCustomerList,
        JobOrderCustomerListError,

        loadingJobOrderIncotermList,
        JobOrderIncotermListError,
        JobOrderIncotermList,

        loadingJobOrderCurrencyList,
        JobOrderCurrencyListError,
        JobOrderCurrencyList,

        loadingJobOrderEntityDetail,
        JobOrderEntityDetail,
        JobOrderEntityDetailError,

        loadingJobOrderDetail,
        JobOrderDetail,
        JobOrderDetailError,
    } = useSelector(state => state?.JoborderReducer);

    const {
        loadingFFAirExpOrganisationList,
        FFAirExpOrganisationList,
        FFAirExpOrganisationListError,

        loadingFFAirExpShipperBranchList,
        FFAirExpShipperBranchList,
        FFAirExpShipperBranchListError,

        loadingFFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchListError,

        loadingFFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankListError,

        loadingFFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankListError,
    } = useSelector(state => state?.FFAirExpReducer);

    useEffect(() => {
        if (loadingJobOrderFreightDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (JobOrderFreightDetail) {
            // existing logic will populate later
        }
    }, [loadingJobOrderFreightDetail, JobOrderFreightDetailError, JobOrderFreightDetail]);

    // Use the same customer list as EntityTab so shipper/consignee IDs always match
    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (JobOrderCustomerList) {
            let arr = [];
            JobOrderCustomerList.map(val =>
                arr.push({
                    value: val.id,
                    label: `${val.name} (${val.customerType})`,
                    entity: val.entity_type ? JSON.parse(val.entity_type) : [],
                })
            );
            setOrganisationOptions(arr);
        }
    }, [JobOrderCustomerList]);

    const [airlineOptions, setAirlineOptions] = useState([]);
    useEffect(() => {
        if (JobOrderAirlineList) {
            let arr = [];
            JobOrderAirlineList.map(v => {
                arr.push({ value: v.id, label: v.name });
            });
            setAirlineOptions(arr);
        }
    }, [JobOrderAirlineList]);

    const [shiplineOptions, setShiplineOptions] = useState([]);
    useEffect(() => {
        if (JobOrderShiplineList) {
            let arr = [];
            JobOrderShiplineList.map(v => {
                arr.push({ value: v.id, label: v.name });
            });
            setShiplineOptions(arr);
        }
    }, [JobOrderShiplineList]);

    const [portOptions, setPortOptions] = useState([]);
    useEffect(() => {
        if (JobOrderPortList) {
            let arr = [];
            JobOrderPortList.map(v => {
                arr.push({ value: v.id, label: v.name });
            });
            setPortOptions(arr);
        }
    }, [JobOrderPortList]);

    const [airportOptions, setAirPortOptions] = useState([]);
    useEffect(() => {
        if (JobOrderAirportList) {
            let arr = [];
            JobOrderAirportList.map(v => {
                arr.push({ value: v.id, label: v.name });
            });
            setAirPortOptions(arr);
        }
    }, [JobOrderAirportList]);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    useEffect(() => {
        if (FFAirExpShipperBranchList) {
            let arr = [];
            FFAirExpShipperBranchList.map(val =>
                arr.push({ value: val.id, label: val.branch_name })
            );
            setShipperBranchOptions(arr);
        }
    }, [FFAirExpShipperBranchList]);

    useEffect(() => {
        if (FFAirExpShipperBranchBankList) {
            let arr = [];
            FFAirExpShipperBranchBankList.map(val =>
                arr.push({ value: val.id, label: val.entity_name })
            );
            setShipperBankOptions(arr);
        }
    }, [FFAirExpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchList) {
            let arr = [];
            FFAirExpConsigneeBranchList.map(val =>
                arr.push({ value: val.id, label: val.branch_name })
            );
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirExpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchBankList) {
            let arr = [];
            FFAirExpConsigneeBranchBankList.map(val =>
                arr.push({ value: val.id, label: val.entity_name })
            );
            setConsigneeBankOptions(arr);
        }
    }, [FFAirExpConsigneeBranchBankList]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes('shipper')) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes('consignee')) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);

    const handleShipperBranch = shipper_id => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = branch_id => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = consignee_id => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = branch_id => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };

    // Shipper/Consignee fallback: freight saved value → entity detail → job order fields
    useEffect(() => {
        if (!loadingJobOrderEntityDetail && !loadingJobOrderFreightDetail && !loadingJobOrderDetail) {
            const freight = JobOrderFreightDetail?.freight || JobOrderFreightDetail;

            // Priority: 1) saved freight value, 2) entity detail, 3) job order fields
            const freightShipperId = freight?.shipper_id ? Number(freight.shipper_id) : 0;
            const freightConsigneeId = freight?.consignee_id ? Number(freight.consignee_id) : 0;
            const entityShipperId = JobOrderEntityDetail?.shipper_customer_id ? Number(JobOrderEntityDetail.shipper_customer_id) : 0;
            const entityConsigneeId = JobOrderEntityDetail?.consignee_customer_id ? Number(JobOrderEntityDetail.consignee_customer_id) : 0;
            const jobShipperId = JobOrderDetail?.customer_id ? Number(JobOrderDetail.customer_id) : 0;
            const jobConsigneeId = JobOrderDetail?.consignee_id ? Number(JobOrderDetail.consignee_id) : 0;

            const resolvedShipper = freightShipperId || entityShipperId || jobShipperId;
            const resolvedConsignee = freightConsigneeId || entityConsigneeId || jobConsigneeId;

            // Always re-resolve shipper/consignee when entity detail changes so that saving
            // in EntityTab is reflected immediately without needing a page reload.
            // If freight already has its own saved shipper/consignee (different from resolved),
            // those freight-specific values take priority and are kept unchanged.
            if (resolvedShipper) {
                formik.setFieldValue('shipper_id', resolvedShipper);
                handleShipperBranch(resolvedShipper);
            }
            if (resolvedConsignee) {
                formik.setFieldValue('consignee_id', resolvedConsignee);
                handleConsigneeBranch(resolvedConsignee);
            }
        }
    }, [loadingJobOrderEntityDetail, loadingJobOrderFreightDetail, loadingJobOrderDetail, JobOrderEntityDetail, JobOrderFreightDetail, JobOrderDetail]);

    // Options for "Type of BL" dropdown
    const blTypeOptions = [
        { value: 'Original BL', label: 'Original BL' },
        { value: 'Seaway BL', label: 'Seaway BL' },
    ];

    const formik = useFormik({
        initialValues: {
            shipper_id: 0,
            shipper_branch_id: 0,
            shipper_branch_bank_account_id: 0,
            consignee_id: 0,
            consignee_branch_id: 0,
            consignee_branch_bank_account_id: 0,
            issuing_carrier_agent_id: 0,
            airport_of_departure_id: 0,
            airport_of_destination_id: 0,
            to_one: '',
            by_first_carrier: '',
            to_two: '',
            by_one: '',
            to_three: '',
            by_two: '',
            flight_no_one: '',
            flight_date_one: '',
            flight_no_two: '',
            flight_date_two: '',
            cto: '',
            currency: '',
            chgs_code: '',
            wt_val: '',
            other: '',
            declared_value_for_carriage: '',
            declared_value_for_customs: '',
            amount_of_insurance: '',
            handling_info: '',
            port_of_loading: 0,
            port_of_discharge: 0,
            place_of_acceptance: '',
            place_of_delivery: '',
            vessel_and_voyage_no: '',
            freight_term: '',
            freight_payable_at: '',
            number_of_original_mdt: '',
            type_of_bl: '',
            no_of_copies: '',
            shipping_line: '',
            place_of_issue: '',
            place_of_date: '',
            notify_address: '',
            notify_email_address: '',
            delivery_of_goods_apply_to_name: '',
            delivery_of_goods_apply_to_address: '',
            delivery_of_goods_apply_to_email: '',
            delivery_of_goods_apply_to_tax_id: 0,
            delivery_of_goods_apply_to_zc: '',
        },
        validate: values => applyNoOfCopiesValidation(values, {}),
        onSubmit: values => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id,
                    },
                };

                values.job_order_id = atob(b64id);
                axios
                    .post(`${adminMainUrl}/api/jobOrder/freight/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshFreightData();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        let msg = 'Internal Server Error!';
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg;
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        },
    });

    function convertTimestampToDate(timestamp) {
        const date = new Date(timestamp);
        return date.toISOString().split('T')[0];
    }

    // useEffect(() => {

    //     if (formik.values) {
    //         console.log(formik.values, 'this is formic value')
    //     }

    // }, [formik])

    // Populate form from freight details AND entity details AND main job order details
    useEffect(() => {
        if (loadingJobOrderFreightDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }


        const freight = JobOrderFreightDetail?.freight || JobOrderFreightDetail;

        if (freight) {
            if (freight.shipper_id) {
                formik.setFieldValue('shipper_id', freight.shipper_id);

                dispatch(getFFAirExpShipperBranch(token, user_id, freight.shipper_id));
            }

            if (freight?.shipper_branch_id) {
                formik.setFieldValue('shipper_branch_id', freight?.shipper_branch_id);
                dispatch(getFFAirExpShipperBranchBank(token, user_id, freight.shipper_branch_id));
            }

            formik.setFieldValue(
                'shipper_branch_bank_account_id',
                freight?.shipper_branch_bank_account_id
            );

            // formik.setFieldValue('consignee_id', freight?.consignee_id);
            if (freight?.consignee_id) {
                formik.setFieldValue('consignee_id', freight?.consignee_id);
                dispatch(getFFAirExpConsigneeBranch(token, user_id, freight.consignee_id));
            }

            // formik.setFieldValue('consignee_branch_id', freight.consignee_branch_id);
            if (freight.consignee_branch_id) {
                formik.setFieldValue('consignee_branch_id', freight.consignee_branch_id);
                dispatch(
                    getFFAirExpConsigneeBranchBank(token, user_id, freight.consignee_branch_id)
                );
            }

            formik.setFieldValue(
                'consignee_branch_bank_account_id',
                freight.consignee_branch_bank_account_id
            );

            formik.setFieldValue(
                'issuing_carrier_agent_id',
                freight.issuing_carrier_agent_id ?? 0
            );

            formik.setFieldValue('airport_of_departure_id', freight.airport_of_departure_id);
            formik.setFieldValue('airport_of_destination_id', freight.airport_of_destination_id);

            formik.setFieldValue('to_one', freight.to_one);
            formik.setFieldValue('by_first_carrier', freight.by_first_carrier);
            formik.setFieldValue('to_two', freight.to_two);
            formik.setFieldValue('by_one', freight.by_one);
            formik.setFieldValue('to_three', freight.to_three);
            formik.setFieldValue('by_two', freight.by_two);
            formik.setFieldValue('flight_no_one', freight.flight_no_one);
            formik.setFieldValue('flight_date_one', freight.flight_date_one);
            formik.setFieldValue('flight_no_two', freight.flight_no_two);
            formik.setFieldValue('flight_date_two', freight.flight_date_two);
            formik.setFieldValue('cto', freight.cto);
            formik.setFieldValue('currency', freight.currency);
            formik.setFieldValue('chgs_code', freight.chgs_code);
            formik.setFieldValue('wt_val', freight.wt_val);
            formik.setFieldValue('other', freight.other);
            formik.setFieldValue(
                'declared_value_for_carriage',
                freight.declared_value_for_carriage
            );
            formik.setFieldValue(
                'declared_value_for_customs',
                freight.declared_value_for_customs
            );
            formik.setFieldValue('amount_of_insurance', freight.amount_of_insurance);
            formik.setFieldValue('handling_info', freight.handling_info);

            if (freight.port_of_loading) {
                formik.setFieldValue('port_of_loading', freight.port_of_loading);
            }
            if (freight.port_of_discharge) {
                formik.setFieldValue('port_of_discharge', freight.port_of_discharge);
            }

            formik.setFieldValue('place_of_acceptance', freight.place_of_acceptance);
            formik.setFieldValue('place_of_delivery', freight.place_of_delivery);
            formik.setFieldValue('vessel_and_voyage_no', freight.vessel_and_voyage_no);
            formik.setFieldValue('freight_term', freight.freight_term);
            formik.setFieldValue('freight_payable_at', freight.freight_payable_at);
            formik.setFieldValue(
                'number_of_original_mdt',
                freight.number_of_original_mdt
            );
            formik.setFieldValue('type_of_bl', freight.type_of_bl || '');
            formik.setFieldValue('no_of_copies', freight.no_of_copies || '');
            formik.setFieldValue('shipping_line', freight.shipping_line || '');
            formik.setFieldValue('place_of_issue', freight.place_of_issue);
            formik.setFieldValue('place_of_date', freight.place_of_date);
            formik.setFieldValue('notify_address', freight.notify_address);
            formik.setFieldValue('notify_email_address', freight.notify_email_address);


            formik.setFieldValue(
                'delivery_of_goods_apply_to_name',
                freight.name || ''
            );

            formik.setFieldValue(
                'delivery_of_goods_apply_to_address',
                freight.delivery_of_goods_apply_to_address
            );
            formik.setFieldValue(
                'delivery_of_goods_apply_to_email',
                freight.delivery_of_goods_apply_to_email
            );
            formik.setFieldValue(
                'delivery_of_goods_apply_to_tax_id',
                freight.delivery_of_goods_apply_to_tax_id
            );
            formik.setFieldValue(
                'delivery_of_goods_apply_to_zc',
                freight.delivery_of_goods_apply_to_zc
            );
        }

    }, [,
        loadingJobOrderFreightDetail,
        JobOrderFreightDetail,
        JobOrderFreightDetailError,
        JobOrderEntityDetail,
        loadingJobOrderEntityDetail,
        JobOrderDetail,
        loadingJobOrderDetail,
    ]);

    return (
        <>
            {showLoader ? (
                <Beatloader />
            ) : (
                <>
                    <div className="row-gap-2">
                        <ul
                            className="nav nav-pills mb-3 custom-tabs gap-0"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link active"
                                    id="Freight-shipping-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#Freight-shipping"
                                    type="button"
                                    role="tab"
                                    aria-controls="Freight-shipping"
                                    aria-selected="true"
                                >
                                    Shipping Details
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div
                                className="tab-pane fade show active"
                                id="Freight-shipping"
                                role="tabpanel"
                                aria-labelledby="Freight-shipping-tab"
                            >
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="row border-bottom-2 pb-3">
                                        <div className="col-md-12">
                                            <div className=" py-2">
                                                <div className="row">
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Shipper
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={shipperOrganisationOptions}
                                                                    styles={customStyles}
                                                                    name="shipper_id"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'shipper_branch_id',
                                                                            ''
                                                                        );
                                                                        setShipperBranchOptions([]);
                                                                        formik.setFieldValue(
                                                                            'shipper_id',
                                                                            option.value
                                                                        );
                                                                        handleShipperBranch(option.value);
                                                                    }}
                                                                    value={shipperOrganisationOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values.shipper_id
                                                                    )}
                                                                    isDisabled={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Shipper Branch
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={shipperBranchOptions}
                                                                    styles={customStyles}
                                                                    name="shipper_branch_id"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'shipper_branch_id',
                                                                            option.value
                                                                        );
                                                                        handleShipperBanks(option.value);
                                                                    }}
                                                                    value={shipperBranchOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values.shipper_branch_id
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Consignee
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={consigneeOrganisationOptions}
                                                                    styles={customStyles}
                                                                    name="quotation_id"
                                                                    onChange={option => {
                                                                        setConsigneeBranchOptions([]);
                                                                        formik.setFieldValue(
                                                                            'consignee_branch_id',
                                                                            ''
                                                                        );
                                                                        formik.setFieldValue(
                                                                            'consignee_id',
                                                                            option.value
                                                                        );
                                                                        handleConsigneeBranch(option.value);
                                                                    }}
                                                                    value={consigneeOrganisationOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values.consignee_id
                                                                    )}
                                                                    isDisabled={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Consignee Branch
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={consigneeBranchOptions}
                                                                    styles={customStyles}
                                                                    name="consignee_branch_id"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'consignee_branch_id',
                                                                            option.value
                                                                        );
                                                                        handleConsigneeBanks(option.value);
                                                                    }}
                                                                    value={consigneeBranchOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values.consignee_branch_id
                                                                    )}
                                                                    isDisabled={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* IATA Agent – commented out by user, leaving as is */}
                                                    {/* <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                IATA Agent
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={iataAgentOptions}
                                                                    styles={customStyles}
                                                                    name="issuing_carrier_agent_id"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'issuing_carrier_agent_id',
                                                                            option.value
                                                                        );
                                                                    }}
                                                                    value={iataAgentOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values
                                                                                .issuing_carrier_agent_id
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    {/* Shipping Line */}
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label mb-0">
                                                                Shipping Line
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control form-control-sm"
                                                                    id="shipping_line"
                                                                    name="shipping_line"
                                                                    value={formik.values.shipping_line}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Notify  */}
                                                    <div className="col-md-12 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Notify Address
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <textarea
                                                                    className="form-control"
                                                                    id="notify_address"
                                                                    name="notify_address"
                                                                    value={formik.values.notify_address}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    maxLength={250}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <InputTextJSX
                                                        labelText={'Notify Email'}
                                                        nameValue={'notify_email_address'}
                                                        value={formik.values.notify_email_address}
                                                        onChange={formik.handleChange}
                                                        maxLength={100}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'Place of acceptance'}
                                                        nameValue={'place_of_acceptance'}
                                                        value={formik.values.place_of_acceptance}
                                                        onChange={formik.handleChange}
                                                        maxLength={100}
                                                    />

                                                    {/* Ports of loading and discharge */}
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Port of Loading
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={portOptions}
                                                                    styles={customStyles}
                                                                    name="port_of_loading"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'port_of_loading',
                                                                            option.value
                                                                        );
                                                                    }}
                                                                    value={portOptions.find(
                                                                        option =>
                                                                            option.value ==
                                                                            formik.values.port_of_loading
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Port of Discharge
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={portOptions}
                                                                    styles={customStyles}
                                                                    name="port_of_discharge"
                                                                    onChange={option => {
                                                                        formik.setFieldValue(
                                                                            'port_of_discharge',
                                                                            option.value
                                                                        );
                                                                    }}
                                                                    value={portOptions.find(
                                                                        option =>
                                                                            option.value ==
                                                                            formik.values.port_of_discharge
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <InputTextJSX
                                                        labelText={'Place of delivery'}
                                                        nameValue={'place_of_delivery'}
                                                        value={formik.values.place_of_delivery}
                                                        onChange={formik.handleChange}
                                                        maxLength={250}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'Vessel & Voyage No.'}
                                                        nameValue={'vessel_and_voyage_no'}
                                                        value={formik.values.vessel_and_voyage_no}
                                                        onChange={formik.handleChange}
                                                        maxLength={250}
                                                    />
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="freight_term" className="form-label mb-0">
                                                                Freight Term
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    inputId="freight_term"
                                                                    className="custom-selector"
                                                                    options={[
                                                                        { value: 'Prepaid', label: 'Prepaid' },
                                                                        { value: 'Collect', label: 'Collect' },
                                                                    ]}
                                                                    styles={customStyles}
                                                                    name="freight_term"
                                                                    isClearable
                                                                    onChange={option => {
                                                                        formik.setFieldValue('freight_term', option ? option.value : '');
                                                                    }}
                                                                    value={
                                                                        formik.values.freight_term
                                                                            ? { value: formik.values.freight_term, label: formik.values.freight_term }
                                                                            : null
                                                                    }
                                                                    placeholder="Select..."
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <InputTextJSX
                                                        labelText={'Freight Payable At'}
                                                        nameValue={'freight_payable_at'}
                                                        value={formik.values.freight_payable_at}
                                                        onChange={formik.handleChange}
                                                        maxLength={250}
                                                    />

                                                    {/* Type of BL dropdown & No. of copies */}
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label mb-0">
                                                                Type of BL
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <Select
                                                                    className="custom-selector"
                                                                    options={blTypeOptions}
                                                                    styles={customStyles}
                                                                    name="type_of_bl"
                                                                    onChange={option => handleTypeOfBlSelectChange(option, formik)}
                                                                    isClearable
                                                                    value={blTypeOptions.find(
                                                                        option =>
                                                                            option.value ===
                                                                            formik.values.type_of_bl
                                                                    ) || null}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-2">
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label mb-0">
                                                                No. of copies
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="text"
                                                                    maxLength={2}
                                                                    className="form-control form-control-sm"
                                                                    id="no_of_copies"
                                                                    name="no_of_copies"
                                                                    value={formik.values.no_of_copies}
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={e => handleNoOfCopiesInputChange(e, formik)}
                                                                    disabled={!formik.values.type_of_bl}
                                                                />
                                                                {formik.errors.no_of_copies && formik.touched.no_of_copies && (
                                                                    <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                                                        {formik.errors.no_of_copies}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <InputTextJSX
                                                        labelText={'Place of issue'}
                                                        nameValue={'place_of_issue'}
                                                        value={formik.values.place_of_issue}
                                                        onChange={formik.handleChange}
                                                    />
                                                    <div className={`col-md-6 mt-2`}>
                                                        <div className="ms-2">
                                                            <label htmlFor="" className="form-label  mb-0">
                                                                Date of Issue
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm"
                                                                    id="place_of_date"
                                                                    name="place_of_date"
                                                                    value={formik.values.place_of_date}
                                                                    onChange={formik.handleChange}
                                                                    min={new Date()
                                                                        .toISOString()
                                                                        .split('T')[0]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <h4 className="mt-2">
                                                        For delivery of goods please apply to:
                                                    </h4>
                                                    <InputTextJSX
                                                        labelText={'Name'}
                                                        nameValue={'delivery_of_goods_apply_to_name'}
                                                        value={formik.values.delivery_of_goods_apply_to_name}
                                                        onChange={formik.handleChange}
                                                        maxLength={100}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'Address'}
                                                        nameValue={'delivery_of_goods_apply_to_address'}
                                                        value={
                                                            formik.values
                                                                .delivery_of_goods_apply_to_address
                                                        }
                                                        onChange={formik.handleChange}
                                                        maxLength={100}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'Email'}
                                                        nameValue={'delivery_of_goods_apply_to_email'}
                                                        value={
                                                            formik.values.delivery_of_goods_apply_to_email
                                                        }
                                                        onChange={formik.handleChange}
                                                        maxLength={60}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'Tax ID'}
                                                        nameValue={'delivery_of_goods_apply_to_tax_id'}
                                                        value={
                                                            formik.values.delivery_of_goods_apply_to_tax_id
                                                        }
                                                        onChange={formik.handleChange}
                                                        maxLength={20}
                                                    />
                                                    <InputTextJSX
                                                        labelText={'ZC'}
                                                        nameValue={'delivery_of_goods_apply_to_zc'}
                                                        value={formik.values.delivery_of_goods_apply_to_zc}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row d-flex justify-content-end my-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button
                                                type="submit"
                                                className="btn btn-sm btn-danger"
                                                disabled={disableSubmit}
                                            >
                                                {disableSubmit ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i> Saving...
                                                    </>
                                                ) : (
                                                    'Update'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="Freight-routing"
                                role="tabpanel"
                                aria-labelledby="Freight-routing-tab"
                            >
                                <RoutingTab />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default FreightSeaTab;